/**
 * Turns the build-time env values (NEXT_PUBLIC_BUILD_ID — a git SHA on real
 * deploys, "dev" locally — and NEXT_PUBLIC_BUILD_TIME) into something a person
 * can read in the account modal. Pure so it's unit-testable; the caller
 * formats `builtAt` for the viewer's locale.
 */

export interface BuildInput {
  buildId: string | null | undefined
  buildTime: string | null | undefined
}

export interface BuildInfo {
  versionLabel: string
  builtAt: Date | null
}

const FULL_SHA = /^[0-9a-f]{40}$/i

export function describeBuild({ buildId, buildTime }: BuildInput): BuildInfo {
  const isDev = !buildId || buildId === 'dev'
  const shortId = buildId && FULL_SHA.test(buildId) ? buildId.slice(0, 7) : buildId

  const parsed = buildTime ? new Date(buildTime) : null
  const builtAt = parsed && !Number.isNaN(parsed.getTime()) ? parsed : null

  return {
    versionLabel: isDev ? 'Development build' : `Version ${shortId}`,
    builtAt,
  }
}
